import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Href } from "../utils/helper"
import TourCard from "./tourCard"
import { Lang, LangEnum } from "../utils/lang"
import AdCard from "./adCard"

const TourList = ({destination, prefecture, season, typeOfTour, keyword, label, interest, duration, sort, tours, adCards}) => {
  // console.log(prefecture, season, typeOfTour, keyword, label);
  // const tours = data?.TouritemItems?.items || [];

  // const lang = Lang()
  // const tours = lang === LangEnum.JA ? jaTours : enTours

  // tours.edges.forEach((e) => {
  //   e.node.content = typeof e.node.content === 'string' ? JSON.parse(e.node.content) : e.node.content;
  // })
  // console.log(tours)
  // console.log(adCards)
  if (!label) {
    label = []
  }
  
  if (interest) {
    label.push(interest)
  }
  
  const filterTours = tours
    .filter((e) => {
      if (!destination) return true;
      return e.content?.destination?.some((d) => d === destination);
    })
    .filter((e) => {
      if (!prefecture) return true;
      return e.content?.prefecture?.some((p) => p.name === prefecture);
    })
    .filter((e) => {
      if (!season) return true;
      return e.content?.season?.some((s) => s === season);
    })
    .filter((e) => {
      if (!typeOfTour) return true;
      return e.content?.typeOfTour === typeOfTour;
    })
    .filter((e) => {
      if (!label) return true;
      return label.every((l) => e.content?.label?.value?.includes(l))
    })
    .filter((e) => {
      if(!duration) return true;
      let durationDays = parseInt(e.content?.durationDays);
      if (durationDays == 1 && duration == '1') return true;
      if (durationDays >= 2 && durationDays <= 3 && duration == '2-3') return true;
      if (durationDays >= 4 && durationDays <= 7 && duration == '4-7') return true;
      if (durationDays >= 8 && duration == '8-') return true;

      if (durationDays >= 2 && durationDays <= 4 && duration == '2-4') return true;
      if (durationDays >= 5 && duration == '5-') return true;
      return false;
    })
    .filter((e) => {
      if (!keyword) return true;
      return e.name?.toLowerCase().includes(keyword) 
          || e.content?.tourTitle?.toLowerCase().includes(keyword)
          || e.content?.tourSubHeading?.toLowerCase().includes(keyword)
          || e.content?.prefecture?.some((p) => p.name.toLowerCase().includes(keyword))
          || e.content?.destination?.some((d) => d.includes(keyword))
          || e.content?.label?.value?.join(',').toLowerCase().includes(keyword)
    })
  // console.log(filterTours)

  if (sort === 'best_season') {
    filterTours.sort((a, b) => {
      const month = new Date().getMonth() + 1;
      console.log(month);
      const monthSeasonMap = {
        1: 'winter',
        2: 'spring',
        3: 'spring',
        4: 'spring',
        5: 'summer',
        6: 'summer',
        7: 'summer',
        8: 'autumn',
        9: 'autumn',
        10: 'autumn',
        11: 'winter',
        12: 'winter'
      }
      const seasonOrder = {
        'winter': {
          'winter': 1,
          'spring': 2,
          'summer': 3,
          'autumn': 4,
          'all seasons': 5,
          '': 6,
        },
        'spring': {
          'spring': 1,
          'summer': 2,
          'autumn': 3,
          'winter': 4,
          'all seasons': 5,
          '': 6,
        },
        'summer': {
          'summer': 1,
          'autumn': 2,
          'winter': 3,
          'spring': 4,
          'all seasons': 5,
          '': 6,
        },
        'autumn': {
          'autumn': 1,
          'winter': 2,
          'spring': 3,
          'summer': 4,
          'all seasons': 5,
          '': 6,
        },
      };

      const aSeason = a.content?.season?.[0] || '';
      const bSeason = b.content?.season?.[0] || '';
      const aOrder = seasonOrder[monthSeasonMap[month]][aSeason] || 6;
      const bOrder = seasonOrder[monthSeasonMap[month]][bSeason] || 6;
      return aOrder - bOrder;
    });
  }

  if (sort === 'energy_level') {
    filterTours.sort((a, b) => {
      const aEnergyLevel = a.content?.energyLevel || 9;
      const bEnergyLevel = b.content?.energyLevel || 9;
      return aEnergyLevel - bEnergyLevel;
    });
  }

  return (
  <div className="container mx-auto">
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10">
    { 
      filterTours?.map((e, i) => {
        return (
        <React.Fragment key={i}>
        {
          adCards?.map((adCard, j) => 
            i + 1 == adCard.position && 
            <AdCard key={j} blok={adCard} />
          )
        }
        <div className="min-h-[400px] border rounded-lg hover:scale-105 hover:shadow-md transition">
          <TourCard blok={e}/>
        </div>
        </React.Fragment>
        )
      })
    }
    {
      adCards?.map((adCard, j) => 
        adCard.position > filterTours.length && 
        <AdCard key={j} blok={adCard} />
      )
    }
    </div>
  </div>
  )
}

export default TourList
